export const dataProducto = [
  {
    id: "1",
    name: "PovibacSolución",
    description: "Iodopovidona 10 %",
    presentation: [
      "60 ml tapa con inserto",
      "100 ml tapa con inserto",
      "250 ml con válvula dosificadora",
      "500 ml con válvula dosificadora",
      "1.000 ml con válvula dosificadora",
      "1.000 ml con tapa",
      "5.000 ml bidón",
    ],
    img: [
      "/assets/lineaHospitalaria/povibacSolucion/pobivac-1-litro-con-valvula-solucion-iodopovidona-10-sertex.jpg",
      "/assets/lineaHospitalaria/povibacSolucion/pobivac-1-litro-solucion-iodopovidona-10-sertex.jpg",
      "/assets/lineaHospitalaria/povibacSolucion/pobivac-5-litros-solucion-iodopovidona-10-sertex.jpg",
      "/assets/lineaHospitalaria/povibacSolucion/pobivac-60ml-solucion-iodopovidona-10-sertex.jpg",
      "/assets/lineaHospitalaria/povibacSolucion/pobivac-250-ml-con-valvulasolucion-iodopovidona-10-sertex.jpg",
      "/assets/lineaHospitalaria/povibacSolucion/pobivac-250ml-solucion-iodopovidona-10-sertex.jpg",
    ],
    imgLogo: "/assets/lineaHospitalaria/povibacSolucion/povibac-solucion.jpg",
    category: "Línea Hospitalaria",
    subcategory: "povibac solucion",
    prospecto: "/assets/prospectos/POVSOL.pdf",
  },
  {
    id: "2",
    name: "PovibacSoluciónJabonosa",
    description: "Iodopovidona 5 %",
    description2: "Tensoactivo aniónico",
    presentation: [
      "100 ml tapa con inserto",
      "250 ml con válvula dosificadora",
      "500 ml con válvula dosificadora",
      "1.000 ml con válvula dosificadora",
      "1.000 ml con tapa",
      "5.000 ml bidón",
    ],
    img: [
      "/assets/lineaHospitalaria/povibacJabonosa/pobivac-1-litro-solucion-jabonosa-iodopovidona-5-sertex.jpg",
      "/assets/lineaHospitalaria/povibacJabonosa/pobivac-250ml-solucion-jabonosa-iodopovidona-5-sertex.jpg",
    ],
    category: "Línea Hospitalaria",
    imgLogo:
      "/assets/lineaHospitalaria/povibacJabonosa/povibac-solucion-jabonosa.jpg",
    subcategory: "povibac solucion jabonosa",
    prospecto: "/assets/prospectos/POVJAB.pdf",
  },
  {
    id: "3",
    name: "LaclorhexJabónLíquido",
    description: "Digluconato de Clorhexidina 4 %",
    description2: "Jabón Líquido",
    presentation: [
      "250 ml con válvula dosificadora",
      "500 ml con válvula dosificadora",
      "1.000 ml con válvula dosificadora",
      "5.000 ml bidón",
    ],
    img: [
      "/assets/lineaHospitalaria/laclorhex/laclorhex-1-litro-digluconato-clorhexidina-4-sertex.jpg",
      "/assets/lineaHospitalaria/laclorhex/laclorhex-5-litros-digluconato-clorhexidina-4-sertex.jpg",
      "/assets/lineaHospitalaria/laclorhex/laclorhex-250ml-digluconato-clorhexidina-4-sertex.jpg",
      "/assets/lineaHospitalaria/laclorhex/laclorhex-500ml-digluconato-clorhexidina-4-sertex.jpg",
    ],
    imgLogo: "/assets/lineaHospitalaria/laclorhex/laclorhex-4.jpg",
    category: "Línea Hospitalaria",
    subcategory: "laclorhex jabon liquido",
    prospecto: "/assets/prospectos/LACLORHEX.pdf",
  },
  {
    id: "4",
    name: "NitrofurazonaSertexPomada",
    description: "Nitrofurazona 0,2 %",
    description2: "Pomada",
    presentation: ["500 g pote"],
    img: [
      "/assets/lineaHospitalaria/nitrofurazonaPomada/nitrofurazona-500g-pomada-antibacteriana-sertex.jpg",
    ],
    imgLogo:
      "/assets/lineaHospitalaria/nitrofurazonaPomada/nitrofurazona-sertex.jpg",
    category: "Línea Hospitalaria",
    subcategory: "laclorhex solucion",
    prospecto: "/assets/prospectos/NITROPOMADA.pdf",
  },
  {
    id: "5",
    name: "NitrofurazonaSertexSolución",
    description: "Nitrofurazona 0,2 %",
    description2: "Solución",
    presentation: ["500 ml con tapa", "1.000 ml con tapa"],
    img: [
      "/assets/lineaHospitalaria/nitrofurazonaSolucion/nitrofurazona-solucion-1-litro-solucion-antibacteriana-sertex.jpg",
      "/assets/lineaHospitalaria/nitrofurazonaSolucion/nitrofurazona-solucion-500ml-solucion-antibacteriana-sertex.jpg",
    ],
    imgLogo:
      "/assets/lineaHospitalaria/nitrofurazonaSolucion/nitrofurazona-sertex.jpg",
    category: "Línea Hospitalaria",
    subcategory: "laclorhex solucion",
  },
  {
    id: "6",
    name: "NitrofurazonaSertexApósitos",
    description: "Nitrofurazona 0,2 %",
    description2: "Apósitos",
    presentation: ["Caja 20 unidades 2 sobres 10 unidades c/u"],
    img: [
      "/assets/lineafarmaceutica/nitrofurazona-apositos/nitrofurazona-apositos-antibacterianos-caja-sertex.jpg",
    ],
    imgLogo:
      "/assets/lineafarmaceutica/nitrofurazona-apositos/nitrofurazona-apositos.jpg",
    category: "Línea Farmacéutica",
    subcategory: "nitrofurazona Apósitos",
    prospecto: "/assets/prospectos/NITROAP.pdf",
  },
  {
    id: "7",
    name: "GelAntiinflamatorio",
    description: "Diclofenac Dietilamina 1,16 %",
    description2: "Gel",
    presentation: [
      "50 g pomo estuchado",
      "50 g caja exhibidora x 20 pomos de 50 g c/u.",
    ],
    img: [
      "/assets/lineafarmaceutica/gelantiinflamatorio/gel-antiinflamatorio-sertex-1.jpg",
    ],
    imgLogo:
      "/assets/lineafarmaceutica/gelantiinflamatorio/gel-antiinflamatorio-sertex.jpg",
    category: "Línea Farmacéutica",
    subcategory: "gel antiinflamatorio",
    prospecto: "/assets/prospectos/GEL.pdf",
  },
  {
    id: "8",
    name: "PovibacSolución60ml",
    description: "Iodopovidona 10 %",
    description2: "Gel",
    presentation: ["60 ml tapa con inserto - Estuchada"],
    img: [
      "/assets/lineafarmaceutica/povibac-solucion/pobivac-60ml-estuchada-solucion-iodopovidona-10-sertex.jpg",
    ],
    imgLogo: "/assets/lineafarmaceutica/povibac-solucion/povibac-solucion.jpg",
    category: "Línea Farmacéutica",
    subcategory: "povibac-solucion-60-ml",
  },
  {
    id: "9",
    name: "LaclorhexDesinfectante",
    description: "Clorhexidina 2 %",
    description2: "Solución Desinfectante",
    presentation: [
      "250 ml con válvula dosificador",
      "500 ml con válvula dosificadora",
      "1.000 ml con válvula dosificadora",
      "5.000 ml bidón",
    ],
    img: [
      "/assets/productosMedicos/laclorhex-desinfectante/laclorhex-desinfectante-5-litros-clorhexidina-2-sertex.jpg",
      "/assets/productosMedicos/laclorhex-desinfectante/laclorhex-desinfectante-250ml-clorhexidina-2-sertex.jpg",
      "/assets/productosMedicos/laclorhex-desinfectante/laclorhex-desinfectante-500ml-clorhexidina-2-sertex.jpg",
    ],
    imgLogo:
      "/assets/productosMedicos/laclorhex-desinfectante/laclorhex-desinfectante.jpg",
    category: "Línea medicos",
    subcategory: "povibac-solucion-60-ml",
  },
  {
    id: "11",
    name: "Glutaraldehídosinsurfactante",
    description: "Glutaraldehído 2 %",
    description2: "Con Surfactante",
    presentation: ["1.000 ml con tapa", "4.000 ml con tapa"],
    img: [
      "/assets/productosMedicos/glutaraldehido-sin-surfactante/glutaraldehido-sin-surfactante-1.jpg",
    ],
    imgLogo:
      "/assets/productosMedicos/glutaraldehido-sin-surfactante/glutaraldehido-sin-surfactante.jpg",
    category: "Línea medicos",
    subcategory: "glutaraldehido-2-con-surfactante",
  },
  {
    id: "12",
    name: "Glutaraldehídoconsurfactante",
    description: "Amilasa, Proteasa y Lipasa",
    description2: "Detergente concentrado enzimático no iónico",
    presentation: ["1.000 ml con tapa", "5.000 ml bidón"],
    img: [
      "/assets/productosMedicos/glutaraldehido-con-surfactante/glutaraldehido-con-surfactante-sertex-1000ml.jpg",
      "/assets/productosMedicos/glutaraldehido-con-surfactante/glutaraldehido-con-surfactante-sertex-4000ml.jpg",
    ],
    imgLogo:
      "/assets/productosMedicos/glutaraldehido-con-surfactante/glutaraldehido-con-surfactante.jpg",
    category: "Línea medicos",
    subcategory: "glutaraldehido-2-con-surfactante",
  },
  {
    id: "12",
    name: "SerteximeNF",
    description: "Amilasa, Proteasa y Lipasa",
    description2: "Detergente concentrado enzimático no iónico",
    presentation: ["1.000 ml con tapa", "5.000 ml bidón"],
    img: [
      "/assets/productosMedicos/sertexime-nf/sertexime-nf-1-litro-detergente-concentrado-enzimatico-no-ionico-sertex.jpg",
      "/assets/productosMedicos/sertexime-nf/sertexime-nf-5-litros-detergente-concentrado-enzimatico-no-ionico-sertex.jpg",
    ],
    imgLogo: "/assets/productosMedicos/sertexime-nf/sertexime-nf.jpg",
    category: "Línea medicos",
  },
];

export const logosHospitalarios = [
  {
    id: "3",
    name: "Povibac Solución",
    img: "/assets/lineaHospitalaria/logos/povibac-solucion.jpg",
    description: "Iodopovidona 10 %",
    description2: "60 ml - 100 ml - 250 ml - 500 ml - 1.000 ml - 5.000 ml",
  },
  {
    id: "4",
    name: "Povibac Solución Jabonosa",
    img: "/assets/lineaHospitalaria/logos/povibac-solucion-jabonosa.jpg",
    description: "Iodopovidona 5 %",
    description2: "100 ml - 250 ml - 500 ml - 1.000 ml - 5.000 ml",
  },
  {
    id: "1",
    name: "Laclorhex Jabón Líquido",
    img: "/assets/lineaHospitalaria/logos/laclorhex-4.jpg",
    description: "Digluconato de Clorhexidina 4 %",
    description2: "60 ml - 250 ml - 500 ml - 1.000 ml - 5.000 ml",
  },
  {
    id: "2",
    name: "Nitrofurazona Sertex Pomada",
    img: "/assets/lineaHospitalaria/logos/nitrofurazona-sertex.jpg",
    description: "Nitrofurazona 0,2 %",
    description2: "Pote 500 g",
  },
  {
    id: "12",
    name: "Nitrofurazona Sertex Solución",
    img: "/assets/lineaHospitalaria/logos/nitrofurazona-sertex.jpg",
    description: "Nitrofurazona 0,2 %",
    description2: "500 ml - 1.000 ml",
  },
];

export const logosFarmaceutico = [
  {
    id: "5",
    name: "Nitrofurazona Sertex Apósitos",
    img: "/assets/lineafarmaceutica/logos/nitrofurazona-apositos.jpg",
    description: "Nitrofurazona 0,2 % - Apósitos Antibacterianos.",
    description2: "Caja x 20 unidades (2 sobres x10 u. c/u)",
  },
  {
    id: "6",
    name: "Gel Antiinflamatorio",
    img: "/assets/lineafarmaceutica/logos/gel-antiinflamatorio-sertex.jpg",
    description: "Diclofenac Dietilamina 1,16 % - Gel.",
    description2: "Pomo 50 g. Estuchado - Caja exhibidora x 20 pomos.",
  },
  {
    id: "7",
    name: "Povibac Solución 60ml",
    img: "/assets/lineafarmaceutica/logos/povibac-solucion.jpg",
    description: "Iodopovidona 10 %",
    description2: "60 ml - Tapa con inserto - Estuchada",
  },
];

export const logosMedico = [
  {
    id: "8",
    name: "Laclorhex Desinfectante",
    img: "/assets/productosMedicos/logos/laclorhex-desinfectante.jpg",
    description: "Clorhexidina 2 %",
    description2: "250 ml - 500 ml - 1.000 ml - 5.000 ml",
  },
  {
    id: "9",
    name: "Glutaraldehído sin surfactante",
    img: "/assets/productosMedicos/logos/glutaraldehido-sin-surfactante.jpg",
    description: "Glutaraldehído 2 %",
    description2: "1.000 ml - 4.000 ml",
  },
  {
    id: "10",
    name: "Glutaraldehído con surfactante",
    img: "/assets/productosMedicos/logos/glutaraldehido-con-surfactante.jpg",
    description: "Glutaraldehído 2 %",
    description2: "1.000 ml - 4.000 ml",
  },
  {
    id: "11",
    name: "Sertexime NF",
    img: "/assets/productosMedicos/logos/sertexime-nf.jpg",
    description: "Amilasa, Proteasa y Lipasa.",
    description2: "1.000 ml - 5.000 ml",
  },
];
